




















































































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import _orderBy from 'lodash/orderBy'
import _filter from 'lodash/filter'
import _shuffle from 'lodash/shuffle'

import AssociationDetailOverlay from '@/components/overlays/AssociationDetailOverlay.vue'
import { IAssociation } from '@/models'

@Component( {
    components: {
        'oe-association-detail-overlay': AssociationDetailOverlay
    },
    computed: mapGetters( {
        associations: 'associationsModule/associations',
        formattedDate: 'globalModule/formattedDate',
        commentsByAssociationId: 'commentsModule/commentsByAssociationId',
        votesByAssociationId: 'associationsModule/votesByAssociationId'
    } )
} )
export default class AssociationsView extends Vue {
    $refs!: {
        associationDetailOverlay: AssociationDetailOverlay;
    }
    associations!: any
    orderFilter = 'date'
    searchQuery = ''
    associationsLimit = 10

    get orderedAssociations() {
        const allAssociations = _filter( this.associations, { language: this.$i18n.locale } )

        switch ( this.orderFilter ) {
            case 'date':
                return _orderBy( allAssociations.slice( 0, this.associationsLimit ), 'dateCreated', ['desc'] )
            case 'votes':
                return _orderBy( allAssociations.slice( 0, this.associationsLimit ), [( o ) => o.relatedUsers.length], ['desc'] )
            case 'comments':
                return _orderBy( allAssociations.slice( 0, this.associationsLimit ), [( o ) => o.relatedComments.length], ['desc'] )
            case 'fuzzy':
                return _shuffle( allAssociations.slice( 0, this.associationsLimit ) )
            case 'search':
                return _filter( allAssociations.slice( 0, this.associationsLimit ), ( o ) => o.contentRaw.includes( this.searchQuery ) )
            default:
                return _orderBy( allAssociations.slice( 0, this.associationsLimit ), 'dateCreated', 'desc' )
        }
    }

    showAssociationDetail( association: IAssociation ) {
        this.$store.commit( 'imagesModule/setCurrentImage', association.relatedImage )
        this.$refs.associationDetailOverlay.showOverlay( association.id )
    }

    loadMore() {
        this.associationsLimit += 10
    }
}
